import _ from 'lodash';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MessageContentComponent } from 'src/app/admin/admin-home/message-center/content/message-center-content.component';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import {
  MandrillEmailTemplateSettings,
  IMandrillEmailMessageTemplate
} from 'src/app/shared/models/mandrillEmailTemplate';

@Component({
  selector: 'preview-template-message',
  templateUrl: 'preview-template-message.component.html',
  styleUrls: ['preview-template-message.component.scss'],
  standalone: false
})
export class PreviewTemplateMessageComponent implements OnInit, OnDestroy {
  @Input() templateName = '';
  @Input() subject = '';
  @Input() fromName = '';
  @Input() replyTo = '';
  @Input() content = '';
  @Input() teamName = '';
  @Input() personId = '';
  @Input() buttonText = '';
  @Input() link = '';
  @Input() isEmailComposed: boolean;
  workspaceLogoUrl: string;
  subscription: Subscription;

  constructor(
    private appConfigService: AppConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private workspaceService: WorkspaceService
  ) {}

  ngOnInit(): void {
    this.subscription = this.workspaceService.activeWorkspaceLogoUrl.subscribe((result) => {
      if (result) {
        this.workspaceLogoUrl = result;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public viewContent(): void {
    this.content = !this.content || this.content.length === 0 ? '' : this.content;
    this.replyTo =
      !this.replyTo || this.replyTo.length === 0
        ? this.appConfigService.tenant.administratorEmail
        : this.replyTo;
    var sender: any = this.appConfigService.tenant.fromEmail ?? 'messages@lineupteams.com';

    var administrator: any = this.appConfigService.tenant.administrator;
    var senderName: any =
      this.fromName && this.fromName.length ? this.fromName : this.appConfigService.tenant.name;
    var unsubscribe =
      window.location.origin +
      '/members/' +
      (this.personId ? this.personId : '{personId}') +
      '/emailPreferences';
    var managePreferences = unsubscribe;

    // If you change anything in mergeVars, make sure to update the MandrillTemplateExtensions class in Draft.Domain
    var template: IMandrillEmailMessageTemplate = {
      name: this.templateName,
      mergeVars: [
        { name: MandrillEmailTemplateSettings.subject, content: this.subject },
        {
          name: MandrillEmailTemplateSettings.logoUrl,
          content: this.workspaceLogoUrl
            ? this.workspaceLogoUrl
            : this.appConfigService.tenant.logoUrl
        },
        { name: MandrillEmailTemplateSettings.sender, content: sender },
        { name: MandrillEmailTemplateSettings.link, content: this.link },
        {
          name: MandrillEmailTemplateSettings.organization,
          content: this.appConfigService.tenant.name
        },
        {
          name: MandrillEmailTemplateSettings.organizationName,
          content: this.appConfigService.tenant.name
        },
        { name: MandrillEmailTemplateSettings.emailHeader, content: this.subject },
        { name: MandrillEmailTemplateSettings.emailContent, content: this.content },
        { name: MandrillEmailTemplateSettings.buttonText, content: this.buttonText },
        { name: MandrillEmailTemplateSettings.fName, content: '' },
        { name: MandrillEmailTemplateSettings.teamName, content: this.teamName },
        {
          name: MandrillEmailTemplateSettings.organizationAdmin,
          content: this.appConfigService.tenant.administrator
        },
        {
          name: MandrillEmailTemplateSettings.organizationEmail,
          content: this.appConfigService.tenant.administratorEmail
        },
        { name: MandrillEmailTemplateSettings.unsubscribe, content: unsubscribe },
        { name: MandrillEmailTemplateSettings.managePreferences, content: managePreferences }
      ]
    };
    // Design Notes: We are passing in a lot of variables in the mergeVars collection above.
    // Each email template will only use a subset of these variables and the mandrill api will just ignore
    // variables it can't use for the particular template.

    this.dialog.open(MessageContentComponent, {
      data: {
        subject: this.subject,
        senderName,
        sender,
        fromName: this.fromName,
        replyTo: this.replyTo,
        template
      },
      width: '95%',
      maxWidth: '1600px',
      height: '95%',
      maxHeight: '1200px'
    });
  }

  close() {
    this.router.navigate(['../details'], { relativeTo: this.route });
  }
}
